import {
  DependentDto,
  DependentsDto,
  FamilyMembersPageData,
} from 'theSource/features/FamilyMembers/types';

export const getDependentFullName = (firstName: string, lastName: string) =>
  `${firstName} ${lastName}`;

export const mapFamilyMembersPageData = (
  data: DependentsDto
): FamilyMembersPageData =>
  data.dependents.map((dependent: DependentDto) => ({
    name: getDependentFullName(dependent.first_name, dependent.last_name),
    path: `${dependent.id}`,
  }));
